// extracted by mini-css-extract-plugin
module.exports =  {"root":"MZ_5ZWROyOhg2ygWvIzZ"};